module.exports = __webpack_public_path__ + "static/media/cms_icon.cdeb238c.svg";